export default {
  namespaced: true,
  state: {
    pendingPropertyCount: 0,
    expiringPropertyCount: 0,
    leaseExpiringCount: 0,
    ownerUpdatePropertyCount: 0,
  },
  mutations: {
    SET_PENDING_PROPERTY(state, count) {
      state.pendingPropertyCount = count
    },
    SET_EXPIRING_PROPERTY(state, count) {
      state.expiringPropertyCount = count
    },
    SET_LEASE_EXPIRING(state, count) {
      state.leaseExpiringCount = count
    },
    SET_OWNER_UPDATE_PROPERTY(state, count) {
      state.ownerUpdatePropertyCount = count
    },
  },
  getters: {
    pendingPropertyCount: s => s.pendingPropertyCount,
    expiringPropertyCount: s => s.expiringPropertyCount,
    leaseExpiringCount: s => s.leaseExpiringCount,
    ownerUpdatePropertyCount: s => s.ownerUpdatePropertyCount,
  },
}
